<template>
  <div v-if="showUpdate" class="update-notification">
    <div class="update-content">
      <div class="update-icon-container">
        <img src="/img/svg/update.svg" alt="update" class="update-icon" />
      </div>
      <div class="update-text">
        <p class="update-title">{{ $t('updateAvailable') }}</p>
        <p class="update-message">{{ $t('updateMessage') }}</p>
      </div>
      <button @click="handleUpdate" class="update-button">
        {{ $t('update') }}
      </button>
    </div>
  </div>
</template>

<script>
import { updateStoredVersion } from '../utils/versionChecker'

export default {
  name: 'UpdateNotification',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showUpdate: false
    }
  },
  watch: {
    show(newVal) {
      this.showUpdate = newVal
    }
  },
  methods: {
    async handleUpdate() {
      // Update stored version before refresh
      await updateStoredVersion()
      // Force refresh the page
      window.location.reload(true)
    }
  },
  mounted() {
    this.showUpdate = this.show
  }
}
</script>

<style scoped>
.update-notification {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 16px 20px;
  /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); */
  z-index: 9999;
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.update-content {
  display: flex;
  align-items: center;
  gap: 16px;
  max-width: 1200px;
  margin: 0 auto;
  direction: rtl;
}

.update-icon-container {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  padding: 8px;
}

.update-icon {
  width: 24px;
  height: 24px;
  filter: brightness(0) invert(1);
}

.update-text {
  flex: 1;
}

.update-title {
  font-size: 16px;
  font-weight: bold;
  margin: 0 0 4px 0;
}

.update-message {
  font-size: 14px;
  margin: 0;
  opacity: 0.9;
}

.update-button {
  flex-shrink: 0;
  background: white;
  color: #667eea;
  border: none;
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); */
}

.update-button:hover {
  background: #f0f0f0;
  transform: translateY(-2px);
  /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); */
}

.update-button:active {
  transform: translateY(0);
}

/* Mobile responsive */
@media (max-width: 768px) {
  .update-content {
    flex-wrap: wrap;
    gap: 12px;
  }

  .update-text {
    width: 100%;
  }

  .update-button {
    width: 100%;
    margin-top: 8px;
  }
}
</style>

